export const mobileNumberRegex = /^[0-9]{10}$/;
export const emailIDRegex =/^[^\s@]+@[^\s@]+\.[^\s@]+$/